import React, {useState, useEffect, FC} from 'react';
import classNames from 'classnames';

import Popup from 'components/__helpers/popup/popup';
import CmsPopup from 'components/popups/cmsPopup/cmsPopup';
import {contentPage} from 'libs/requests/cmsPage/cmsPage';
import {TERMS_AND_CONDITIONS} from 'constants/cmsContent/cmsContent';
import {Loader} from 'components/__helpers/loader/loader';
import {Z_INDEX} from 'constants/cssVariables';

import s from './termsOfUse.scss';

export type PropsType = {
    title?: string;
    className?: string;
    onTogglePopup?: (isVisible: boolean) => void;
};

/**
 * Tearms of Use
 *
 * @param {PropsType} props - component props
 * @returns {FC} - component
 */
export const TermsOfUse: FC<PropsType> = ({
    className = '',
    title = 'Terms of Use',
    onTogglePopup,
}) => {
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [content, setContent] = useState('');

    useEffect(() => {
        if (isPopupVisible && !content) {
            contentPage.getContent(TERMS_AND_CONDITIONS).then(result => {
                setContent(result.error === true ? result.message : result.content);
            });
        }
    }, [content, isPopupVisible]);

    const togglePopup = () => {
        if (onTogglePopup) onTogglePopup(!isPopupVisible);
        setPopupVisible(!isPopupVisible);
    };

    return (
        <>
            <button type="button" className={classNames(s.link, className)} onClick={togglePopup}>
                {title}
            </button>
            <Popup
                visible={isPopupVisible}
                onClose={togglePopup}
                zIndex={Z_INDEX['--zIndex-tooltip']}
            >
                {content ? (
                    <CmsPopup cms={content} />
                ) : (
                    <div className={s.loader}>
                        <Loader />
                    </div>
                )}
            </Popup>
        </>
    );
};
